import React from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import {publicBuildUrl} from '../../config/config';
import {CountdownCircleTimer} from "react-countdown-circle-timer";
import Api from "../../util/api";
import {navigateNext} from "../../action/actions";
import {useDispatch} from "react-redux";

const fancyTimeFormat = (duration) => {
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;

    let ret = '';
    ret += '0' + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;

    return ret;
}

const Tick = ({angle}) => (
    <div style={{
        ...styles.clockTickContainer,
        transform: 'rotate(' + angle + 'deg)',
    }}>
        <div className={'timerAnimatedColor'} style={styles.clockTick}/>
    </div>
);

Tick.propTypes = {
    angle: PropTypes.number.isRequired,
};

const Question = ({seconds = 60, title = 'Beantwoord de vraag op je toestel', context = false}) => {
    const dispatch = useDispatch();

    const handleOnComplete = () => {
        Api.navigateDeviceNext().then(
            () => dispatch(navigateNext())
        );
    }

    const renderTime = (props) => {
        const {elapsedTime, remainingTime} = props;
        const percentage = ((seconds - elapsedTime) / seconds) * 100;
        const invertPercentage = ((100 - percentage) * 3.6) + 90;

        return (
            <div>
                <Tick angle={0}/>
                <Tick angle={45}/>
                <Tick angle={90}/>
                <Tick angle={135}/>
                <Tick angle={180}/>
                <Tick angle={225}/>
                <Tick angle={270}/>
                <Tick angle={315}/>
                <div style={{
                    ...styles.clockWandContainer,
                    transform: 'rotate(' + invertPercentage + 'deg)',
                }}>
                    <div className={'timerAnimatedColor'} style={styles.clockWand}/>
                </div>

                {remainingTime !== 0 &&
                    <div className='timer' style={{position: 'absolute', left: '220px', top: '25px'}}>
                        <div className='value' style={styles.timer}>{fancyTimeFormat(remainingTime)}</div>
                    </div>}
            </div>
        );
    }

    return (
        <Page title={''}>
            <div className={'bodyContainer'} style={{justifyContent: 'center'}}>
                <div style={styles.container}>
                    <div style={styles.title}>{title}</div>

                    <div className={'bodyContainer'} style={{width: '80vw', paddingLeft: 0, paddingRight: 0, justifyContent: 'center'}}>
                        <div className={'bodyContainerColumn'} style={{
                            ...styles.row,
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '-50px',
                        }}>
                            <img style={styles.tablet} src={`${publicBuildUrl}icons/IconTablet.png`} alt={'Beantwoord de vraag op je tablet'}/>
                            <div style={styles.tabletText}>Beantwoord de vraag op je toestel</div>
                        </div>
                        <div className={'bodyContainerColumn'} style={{
                            ...styles.row,
                            justifyContent: 'center',
                        }}>
                            <div style={{marginBottom: '50px', fontSize: '24px', fontWeight: 'bold', color: '#427A83', textAlign: 'center'}}>
                                {context && context.split('\n').map((item, key) => (<span key={key}>{item}<br/></span>))}
                                {!context && "Beoordeel aan de hand van de tool ‘Miro’ of de situatie van Milan wel of niet oké is."}
                            </div>
                            <CountdownCircleTimer
                                isPlaying={true}
                                duration={seconds}
                                colors={[
                                    ['#228D83', .5],
                                    ['#e4195f', .5],
                                ]}
                                onComplete={handleOnComplete}
                            >
                                {renderTime}
                            </CountdownCircleTimer>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}

Question.propTypes = {
    seconds: PropTypes.number,
    title: PropTypes.string,
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '80vw',
    },
    row: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContents: 'flex-start',
    },
    tablet: {
        marginBottom: '80px',
        marginTop: '80px',
        width: '250px'
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '36px',
        lineHeight: '36px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '105px',
        width: '100%',
    },
    tabletText: {
        color: '#e4195f',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    clockTickContainer: {
        position: 'absolute',
        height: '140px',
        width: '140px',
        left: 20,
        top: 20,
        display: 'flex',
        alignItems: 'center',
    },
    clockTick: {
        borderRadius: 5,
        width: '14px',
        height: '4px',
    },
    clockWandContainer: {
        position: 'absolute',
        height: '140px',
        width: '140px',
        left: 20,
        top: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    clockWand: {
        borderRadius: 5,
        width: '36px',
        height: '4px',
        marginLeft: '-25px',
    },
    timer: {
        color: '#e4195f',
        fontFamily: 'Ubuntu',
        fontStyle: 'italic',
        fontWeight: 'bold',
        fontSize: '85px',
        lineHeight: '85px',
    }
}

export default Question;
